/**
 * Parents API
 * Operations for parent account management
 */

import { apiRequest, type APIResponse } from './client';

export interface Parent {
  parentId: string;
  parentName: string;
  email: string;
  linkedDate: string;
}

export interface CreateParentData {
  parentName: string;
  email: string;
  password: string;
  studentId: string;
}

/**
 * Get all parent accounts linked to a student
 */
export const getStudentParents = async (studentId: string): Promise<APIResponse<{ parents: Parent[] }>> => {
  return apiRequest('get_student_parents', { studentId });
};

/**
 * Create a new parent account and link to student
 */
export const createParentAccount = async (
  data: CreateParentData
): Promise<APIResponse<{ parent: Parent; message: string }>> => {
  return apiRequest('create_parent_account', data as unknown as Record<string, unknown>);
};

/**
 * Disconnect a parent from a student
 */
export const disconnectParent = async (
  studentId: string,
  parentId: string
): Promise<APIResponse<{ message: string }>> => {
  return apiRequest('disconnect_parent', { studentId, parentId });
};
